export default "__VITE_ASSET__98ffcdfe__"